import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import {DB_ROLE} from "../../constants/roles.constant";
import {RoleBasedParamModel} from "../../models/role-based-param.model";
import {AuthService} from "../../services/auth.service";

@Component({
    selector: 'bwp-top-toolbar',
    templateUrl: './top-toolbar.component.html',
    styleUrls: ['./top-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopToolbarComponent implements OnInit {
  @Input() showMenuDesktop = false;
  @Input() type = 'user';
  @Output() toggleMenu: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  toggled: boolean = false;
  isMobile: boolean = false;

  constructor(
    private router: Router,
		private authService: AuthService,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {}

  get homeUrl(): string {
    return this.authService.homeUrl(AuthService.appForUrl(this.router.url));
  }

  /** The side menu toggle is only shown in ESS; New PTM has a single page and keeps its menu closed. */
  get showMenuToggle(): boolean {
    return AuthService.appForUrl(this.router.url) === 'ess';
  }

  get titleKey(): string {
    return AuthService.appForUrl(this.router.url) === 'ess' ? 'ess-title' : 'title';
  }

  toggle() {
    this.toggled = !this.toggled;
    this.toggleMenu.emit(this.toggled);
  }

  logout() {
    this.authService.logout();
  }

  refreshPage(){
    window.location.reload();
  }
}
